import { getFormSubmitEvent } from '@app/components/common/analytics/analyticsUtils';
import { getCommaSeparatedObjectValues } from '../../../utils';
import {
  PLACE_ORDER_FORM_NAME,
  PENDING_QUOTE_DETAILS,
  PURCHASE_ORDER_NUMBER,
  SUMMARY_AND_PAYMENT_CREATE_QUOTE,
  PO_NOT_CHANGED,
  PO_CHANGED
} from './PaymentGateways/DefaultGateway/analyticsConstants';

export const getAddressSubmitEventForServiceFail = ({
  isInlineForm,
  isAddressEditForm,
  payload
}) => {
  let formSubmitVal = 'Edit Billing Address';
  let formContent = 'Address Updated';
  if (isInlineForm) {
    formSubmitVal = 'Billing Address Submit';
    formContent = 'Address Submitted';
  }
  if (!isInlineForm && !isAddressEditForm) {
    formSubmitVal = 'Add Billing Address';
    formContent = 'Address Added';
  }
  return {
    event: 'formSubmitted',
    pagePath: window.location.pathname,
    formName: formSubmitVal,
    formContent: formContent,
    formContent2: 'AVI, none',
    formStatus: 'fail',
    formFieldCausingError: payload?.message[0],
    formLocation: ''
  };
};
export const getAddressSubmitEventForServiceSuccess = ({
  aviOptionSelected,
  isAddressEditForm,
  isInlineForm
}) => {
  const aviSelected =
    aviOptionSelected === 'suggested' ? 'recommended' : aviOptionSelected;
  const formContent2 = aviSelected ? aviSelected : 'None';
  let formSubmitVal = 'Edit Billing Address';
  let formContent = 'Address Updated';
  if (isInlineForm) {
    formSubmitVal = 'Billing Address Submit';
    formContent = 'Address Submitted';
  }
  if (!isInlineForm && !isAddressEditForm) {
    formSubmitVal = 'Add Billing Address';
    formContent = 'Address Added';
  }
  return {
    event: 'formSubmitted',
    pagePath: window.location.pathname,
    formName: formSubmitVal,
    formContent: formContent,
    formContent2: formContent2 ? `AVI, ${formContent2}` : 'AVI, none',
    formStatus: 'success',
    formFieldCausingError: '',
    formLocation: ''
  };
};
export const getOrderBySubmitEventForFieldValidation = ({ payload }) => {
  return {
    event: 'formSubmitted',
    pagePath: window.location.pathname,
    formName: 'Ordered by',
    formContent: '',
    formContent2: '',
    formStatus: 'fail',
    formFieldCausingError: getCommaSeparatedObjectValues(payload?.errors),
    formLocation: ''
  };
};
export const getOrderBySubmitEventForServiceFail = ({ payload }) => {
  return {
    event: 'formSubmitted',
    pagePath: window.location.pathname,
    formName: 'Ordered by',
    formContent: '',
    formContent2: '',
    formStatus: 'fail',
    formFieldCausingError: payload,
    formLocation: ''
  };
};
export const getOrderBySubmitEventForServiceSuccess = () => {
  return {
    event: 'formSubmitted',
    pagePath: window.location.pathname,
    formName: 'Ordered by',
    formContent: '',
    formContent2: '',
    formStatus: 'success',
    formFieldCausingError: '',
    formLocation: ''
  };
};
const getPoSubmitEventForFieldValidation = (
  formContent,
  formFieldCausingError,
  gaFormName = ''
) => {
  const isPlaceOrderAction =
    gaFormName === PLACE_ORDER_FORM_NAME ||
    gaFormName === SUMMARY_AND_PAYMENT_CREATE_QUOTE;
  return {
    event: 'formSubmitted',
    pagePath: window.location.pathname,
    formName: gaFormName || PURCHASE_ORDER_NUMBER,
    formContent: isPlaceOrderAction ? '' : formContent,
    formContent2: '',
    formStatus: 'fail',
    formFieldCausingError: formFieldCausingError,
    formLocation: ''
  };
};

const formatFormFieldCausingErrorString = (payload, errorFieldKeys) => {
  let formFieldCausingError;
  if (payload?.errors?.poNumber === errorFieldKeys.poNumberError) {
    formFieldCausingError = payload?.errors.poNumber;
  }
  if (
    payload === errorFieldKeys.poAttachmentError ||
    payload?.errors?.poAttachment?.file
  ) {
    formFieldCausingError = payload?.errors?.poAttachment?.file
      ? payload?.errors?.poAttachment?.file
      : payload;
  }
  if (payload?.errors?.poNumber === errorFieldKeys.poNumberAttachmentError) {
    formFieldCausingError = payload?.errors?.poNumber;
  }
  return formFieldCausingError;
};

export const getPoSubmitEventForFieldValidationByFormikErrors = ({
  payload,
  errorFieldKeys,
  gaFormName
}) => {
  let formContent;
  const formFieldCausingError = formatFormFieldCausingErrorString(
    payload,
    errorFieldKeys
  );
  if (payload?.errors?.poNumber === errorFieldKeys.poNumberError) {
    formContent = 'PO Number';
  }
  if (
    payload === errorFieldKeys.poAttachmentError ||
    payload?.errors?.poAttachment?.file
  ) {
    formContent = 'PO Attachment';
  }
  if (payload?.errors?.poNumber === errorFieldKeys.poNumberAttachmentError) {
    formContent = 'PO Number + PO Attachment';
  }
  return getPoSubmitEventForFieldValidation(
    formContent,
    formFieldCausingError,
    gaFormName
  );
};

export const getPoSubmitEventForServiceFail = ({ payload = {} }) => {
  return {
    event: 'formSubmitted',
    pagePath: window.location.pathname,
    formName: 'Purchase Order Number',
    formContent: 'PO Number + Po Attachment',
    formStatus: 'fail',
    formContent2: '',
    formFieldCausingError: payload?.config?.timeout ? 'Timeout Error' : payload,
    formLocation: ''
  };
};
export const getPoSubmitEventForPoFileFormatValidation = ({ fileError }) => {
  return {
    event: 'formSubmitted',
    pagePath: window.location.pathname,
    formName: 'Purchase Order Number',
    formContent: 'PO Attachment',
    formStatus: 'fail',
    formContent2: '',
    formFieldCausingError: fileError,
    formLocation: ''
  };
};
export const getPoSubmitEventForServiceSuccess = ({ response = {} }) => {
  const poNumberContent = response.poNumber ? 'PO Number' : '';
  const poAttachmentContent = response.poAttachmentName
    ? `${response.poNumber ? ', ' : ''}PO Attachment`
    : '';
  return {
    event: 'formSubmitted',
    pagePath: window.location.pathname,
    formName: 'Purchase Order Number',
    formContent: poNumberContent + poAttachmentContent,
    formContent2: '',
    formStatus: 'success',
    formFieldCausingError: '',
    formLocation: ''
  };
};
export const getPromoCodeSubmitEventForFieldValidation = ({
  promotionCode
}) => {
  return {
    event: 'formSubmitted',
    pagePath: window.location.pathname,
    formName: 'Promo Code',
    formContent: '',
    formContent2: '',
    formStatus: 'fail',
    formFieldCausingError: promotionCode?.errors.promotionCode
      ? promotionCode?.errors.promotionCode
      : promotionCode?.errors,
    formLocation: ''
  };
};
export const getPromoCodeSubmitEventForServiceFail = ({ payload }) => {
  return {
    event: 'formSubmitted',
    pagePath: window.location.pathname,
    formName: 'Promo Code',
    formContent: '',
    formContent2: '',
    formStatus: 'fail',
    formFieldCausingError: payload?.response?.data.errors[0].errorMessage,
    formLocation: ''
  };
};
export const getPromoCodeSubmitEventForServiceSuccess = () => {
  return {
    event: 'formSubmitted',
    pagePath: window.location.pathname,
    formName: 'Promo Code',
    formContent: '',
    formContent2: '',
    formStatus: 'success',
    formFieldCausingError: '',
    formLocation: ''
  };
};

export const getPONumberSubmitEventForPendingQuoteDetails = gaValues => {
  const {
    dealerCode,
    quoteNumber,
    status,
    error = '',
    POChanged,
    gaFormName
  } = gaValues;
  const poChange = POChanged ? PO_CHANGED : PO_NOT_CHANGED;
  const isPlaceOrderAction =
    gaFormName === PLACE_ORDER_FORM_NAME ||
    gaFormName === SUMMARY_AND_PAYMENT_CREATE_QUOTE;
  return getFormSubmitEvent({
    formContent: isPlaceOrderAction ? '' : `${dealerCode} | ${quoteNumber}`,
    formContent2: isPlaceOrderAction ? '' : poChange,
    formFieldCausingError: error,
    formName:
      gaFormName === PLACE_ORDER_FORM_NAME
        ? PLACE_ORDER_FORM_NAME
        : PENDING_QUOTE_DETAILS,
    formStatus: status
  });
};

export const getPoModalSubmitEventForServiceSuccess = ({ response = {} }) => {
  const poNumberContent = response.poNumber ? 'PO Number Provided' : '';
  const poAttachmentContent =
    response.poAttachmentName.length > 0
      ? `${response.poAttachmentName.length} PO Attachment(s)`
      : '';
  return {
    event: 'formSubmitted',
    pagePath: window.location.pathname,
    formName: 'Purchase Order Number',
    formContent: poNumberContent,
    formContent2: poAttachmentContent,
    formFieldCausingError: null,
    formLocation: '',
    formStatus: 'Success'
  };
};

const getPoModalErrorFormContent = payload => {
  return payload.errors?.poNumber
    ? null
    : payload.values.poNumber
    ? 'PO Number Provided'
    : null;
};
const getPoModalErrorFormContent2 = payload => {
  const poAttachementLength = payload.values.poAttachment.length;
  return payload.errors?.poAttachment
    ? null
    : poAttachementLength > 0
    ? `${poAttachementLength} PO Attachment(s)`
    : null;
};

export const getPoModalSubmitEventForFieldValidationByFormikErrors = ({
  payload,
  errorFieldKeys
}) => {
  const formContent = getPoModalErrorFormContent(payload);
  const formContent2 = getPoModalErrorFormContent2(payload);
  let formFieldCausingError = [];
  if (payload?.errors?.poNumber) {
    const isPoNumberAttachmentError =
      payload.errors?.poNumber === errorFieldKeys.poNumberAttachmentError &&
      !payload.values.poNumber &&
      payload.values.poAttachment.length === 0;
    formFieldCausingError.push(
      isPoNumberAttachmentError
        ? 'Purchase Order Number,File Upload'
        : 'Purchase Order Number'
    );
  }
  if (payload?.errors?.poAttachment) {
    formFieldCausingError.push('File Upload');
  }
  return {
    event: 'formSubmitted',
    pagePath: window.location.pathname,
    formName: 'Purchase Order Number',
    formContent: formContent,
    formContent2: formContent2,
    formFieldCausingError: formFieldCausingError.join(','),
    formLocation: '',
    formStatus: 'Fail'
  };
};
